import { Component } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

@Component({
  selector: 'cigna-layout-wrapper',
  templateUrl: './layout-wrapper.component.html',
  styleUrls: ['./layout-wrapper.component.scss'],
})
export class LayoutWrapperComponent {
  constructor(private featureTogglesFacade: FeatureTogglesFacade) {}

  trustEnabled$ = this.featureTogglesFacade.featuresEnabled(['trust']);
}
